export default "__VITE_ASSET__Dfjwzk$0__"